import { motion, AnimatePresence } from 'framer-motion';
import { useHeroCarousel } from '@/hooks/useHeroCarousel';

// Ken Burns animation variants — same as HomeHero
const kenBurnsVariants = [
  { scale: [1, 1.04], x: [0, -8], y: [0, -5] },
  { scale: [1, 1.05], x: [0, 8], y: [0, -4] },
  { scale: [1, 1.03], x: [0, -5], y: [0, 6] },
  { scale: [1, 1.04], x: [0, 6], y: [0, 4] },
  { scale: [1, 1.05], x: [0, 0], y: [0, 0] },
  { scale: [1.03, 1], x: [-5, 5], y: [0, 0] },
];

export const AuthBackground = () => {
  const { currentSlide, currentIndex } = useHeroCarousel();

  return (
    <>
      <AnimatePresence mode="sync">
        <motion.img
          key={currentSlide.id}
          src={currentSlide.backgroundImage}
          alt={currentSlide.backgroundAlt}
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0, scale: 1 }}
          animate={{
            opacity: 1,
            scale: kenBurnsVariants[currentIndex % kenBurnsVariants.length].scale,
            x: kenBurnsVariants[currentIndex % kenBurnsVariants.length].x,
            y: kenBurnsVariants[currentIndex % kenBurnsVariants.length].y,
          }}
          exit={{ opacity: 0 }}
          transition={{
            opacity: { duration: 1.2, ease: 'easeInOut' },
            scale: { duration: 8, ease: 'linear' },
            x: { duration: 8, ease: 'linear' },
            y: { duration: 8, ease: 'linear' },
          }}
          onError={(e) => {
            e.currentTarget.src =
              currentSlide.fallbackBackground ?? '/hero-car-background.webp';
          }}
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-black/70" />
    </>
  );
};
